import TruncateText from '@creditflowresearch/uilib/TruncateText';
import { useTableDictionaries } from '@/creditflowresearch/application/TableDictionaries';

type DisplayField = 'abbreviation' | 'displayName' | 'name' | 'code';

interface IDictionaryAbbreviationCellProps {
  id: string | null,
  dictionaryKey: string,
  displayField?: DisplayField,
}

const DictionaryAbbreviationCell = ({
  id,
  dictionaryKey,
  displayField = 'abbreviation',
}: IDictionaryAbbreviationCellProps) => {
  const dictionaries = useTableDictionaries();

  if (!id) {
    return (<>-</>);
  }

  const accessor = dictionaries[dictionaryKey];
  const item = accessor?.getById(id);

  if (!item) {
    return (<>{ id }</>);
  }

  const display = item[displayField] || item.abbreviation || item.name;

  return (
    <TruncateText value={ item.name } shouldShowTooltip>
      { display }
    </TruncateText>
  );
};

export default DictionaryAbbreviationCell;
